export default "__VITE_ASSET__e$A6gnvn__"